import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(100%);
    }
`;

const Shimmer = styled.div`
    position: relative;
    overflow: hidden;
    background: #ececec;
    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.7), transparent);
        animation: ${shimmer} 1.4s infinite;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    gap: 32px;

    width: 100%;
    align-items: start;
`;

export const Card = styled.div`
    background: white;
    border: 1px solid #ddd;
    border-radius: 16px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const Header = styled.div`
    display: flex;
    gap: 16px;
`;

export const Image = styled(Shimmer)`
    width: 80px;
    height: 80px;
    border-radius: 12px;
    flex-shrink: 0;
`;

export const Info = styled.div`
    flex: 1;
`;

export const Line = styled(Shimmer)<{
    width: string;
    height?: number;
}>`
    width: ${({ width }) => width};
    height: ${({ height = 14 }) => `${height}px`};
    border-radius: 6px;
    margin-bottom: 10px;
`;

export const Section = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const Label = styled(Shimmer)`
    width: 120px;
    height: 14px;
    border-radius: 6px;
`;

export const Input = styled(Shimmer)`
    width: 100%;
    height: 40px;
    border-radius: 10px;
`;

export const Chips = styled.div`
    display: flex;
    gap: 8px;
`;

export const Chip = styled(Shimmer)`
    width: 100px;
    height: 34px;
    border-radius: 10px;
`;

export const Pagination = styled.div`
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const Summary = styled(Shimmer)`
    width: 140px;
    height: 18px;
    border-radius: 6px;
`;

export const Pages = styled.div`
    display: flex;
    gap: 10px;
`;

export const Page = styled(Shimmer)`
    width: 36px;
    height: 36px;
    border-radius: 8px;
`;

export const Rows = styled(Shimmer)`
    width: 160px;
    height: 40px;
    border-radius: 10px;
`;
